/* eslint-disable no-unused-vars */
import { observable, action, makeObservable } from 'mobx';
import { getCourseDetail, getStudentNum, getOpenChapterList, getChapterList, inviteCheck, studentCheck, invitationCodeStudent, improveInfoDetail, submitImproveInfo,projectCheck } from '@/api/openCourse';
import { getProductDetail } from '@/api/Payment/order';
import _ from 'lodash';
import { convertTree, sortTreeData } from '@/utils/convertTree';
import Toast from '@/components/Toast';
class Detail {
    constructor() {
        makeObservable(this);
    }
    @observable state = {
        data: {},
        learnNum: 0,
        urlData: {},
        chapterList: [],
        productDetail: {},
        auth_token:'',
        isInviteCheck:{},
        inviteCheckResult:{},
        loading:true,
        isLinkDetail:false,
        isProjectStudent: false
    };
    @action setState = (data) => {
        this.state = Object.assign({}, this.state, data);
    };
    inviteCheck = async (isLoading) => {
        if(!isLoading){
            this.setState({
                loading:true
            });
        }
        let { business_id, template_id,class_id,invitation_code } = this.state.urlData;
        const res = await inviteCheck({ business_id, template_id,class_id,invitation_code,invite_type_key:1 });
        if(!isLoading){
            this.setState({
                isInviteCheck: res
            });
        }
        return res;
    };
    projectCheck = async (isLogin) => {
        if (!isLogin) {
            return false;
        }
        let { business_id, template_id } = this.state.urlData;
        const res = await projectCheck({ business_id, template_id });
        let flag = false;
        if (res && res.data) {
            flag = true;
        }
        this.setState({
            isProjectStudent: flag
        });
    };
    studentCheck = async () => {
        this.setState({
            loading:true
        });
        let { business_id, template_id,class_id,invitation_code } = this.state.urlData;
        const res = await studentCheck({ business_id, template_id,class_id,invitation_code,invite_type_key:1 });
        if (res && res.code === 'A2158') {
            this.setState({
                auth_token: res.stack_trace
            });
        }
        this.setState({
            studentCheckResult: res,
            loading:false
        });
        return res;
    };
    invitationCodeStudent = async () => {
        let { business_id, template_id,class_id,invitation_code } = this.state.urlData;
        const res = await invitationCodeStudent({ business_id, template_id,class_id,invitation_code,invite_type_key:1 });
        return res;
    };

    //获取学习数
    fetchNum = async () => {
        let { business_id, template_id } = this.state.urlData,
         res = await getStudentNum({ business_id, template_id });
        if (res && res.success) {
            this.setState({
                learnNum: res.data
            });
        }
    };
    //获取课程详情
    fetchDetail = async () => {
        let { business_id, template_id, class_id } = this.state.urlData,
         res = await getCourseDetail(business_id, { template_id, class_id });
        if (res && res.success) {
            this.setState({
                data: res.data
            });
        }
        return res;
    };

    //获取章节列表
    fetchOpenChapterList = async (open = true) => {
        let fn = open ? getOpenChapterList : getChapterList,
         resList = [],
         { business_id, template_id } = this.state.urlData,
         res = await fn({ business_id, template_id }).catch(() => {
            return resList;
        });
        if (res && res.success) {
            resList = convertTree(sortTreeData(res.data));
            this.setState({
                chapterList: resList
            });
        }
        return resList;
    };
    //获取商品详情
    getProductDetail = async () => {
        let { business_id } = this.state.urlData,
         res = await getProductDetail(business_id);
        if (res && res.success && res.data) {
            this.setState({
                productDetail: res.data,
                sku_info: res.data.sku_info.length ? res.data.sku_info[0] : null,
                join_flag: res.data.join_flag,
                show_flag: res.data.show_flag
            });
        } else {
            this.setState({
                sku_info: null,
                join_flag: false,
                show_flag: false
            });
        }
        return res;
    };

    // 完善信息
    @observable improve_info = {};
    @action
    setImproveInfo(info) {
        this.improve_info = info;
    }
    @observable informationVisible = false;

    @action
    setInformationVisible = (v) => {
        this.informationVisible = v;
    };


    // 获取学员完善信息
    improveInfoDetail = async (form, isRegister) => {
        // this.setAuthToken(form);
        const { msg, code, data } = await improveInfoDetail(form);
        if (code === '00000') {
            this.setImproveInfo(data);
            // this.setIsRegister(isRegister);
            this.setInformationVisible(true);
        } else {
            return Toast.error(msg);
        }
    };

    // 学员完善信息提交
    submitImproveInfo = async (form) => {
        const { msg, code } = await submitImproveInfo({ ...form, ...{auth_token:this.state.auth_token} });
        if (code === '00000') {
            this.setInformationVisible(false);
            this.setState({
                isLinkDetail:true
            });
        } else {
            return Toast.error(msg);
        }
    };
}
export default new Detail();
